"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AEmailTypes = void 0;
exports.AEmailTypes = ['simpleEmail', 'autoMessageConfigurationEmail', 'bluaChemistDeliveryNPSSurveyEmail', 'csvEmail', 'baseEmail', 'marketPlacePharmacyTransactional', 'newCustomerPassword', 'newPharmacyPassword', 'passwordChangedConfirmationEmail', 'pharmacyComment', 'pharmacyTransactional', 'refundReceiptToCustomer', 'reminderItemsInCartEmail', 'userTransactionalComplete', 'userTransactional'];
